<template>
  <div ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import * as echarts from 'echarts'

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
  },
})

const chartRef = ref(null)
let chartInstance = null

const initChart = () => {
  if (chartRef.value) {
    chartInstance = echarts.init(chartRef.value)
    updateChart(props.chartData)
  }
}

const updateChart = (data) => {
  if (!chartInstance || !chartRef.value) return
  const isMobile = chartRef.value.clientWidth < 480

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      orient: isMobile ? 'horizontal' : 'vertical',
      left: isMobile ? 'center' : 'left',
      top: isMobile ? 'bottom' : 'middle',
      data: data.map(item => item.name),
      textStyle: {
        fontSize: isMobile ? 11 : 12,
      },
    },
    series: [
      {
        name: '设备状态',
        type: 'pie',
        radius: isMobile ? ['36%', '58%'] : ['40%', '70%'],
        center: isMobile ? ['50%', '42%'] : ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: isMobile ? 14 : 20,
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  }

  chartInstance.setOption(option)
}

const handleResize = () => {
  if (!chartInstance) return
  chartInstance.resize()
  updateChart(props.chartData)
}

onMounted(() => {
  initChart()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }
})

watch(() => props.chartData, (newData) => {
  updateChart(newData)
})
</script>
